import { EventEmitter, Input, Output, Directive } from "@angular/core";
import { Transaction, TransactionState } from "@brain/pages/checkout/data/transaction";

export enum CardAction {
    DELETE_CARD,
    SHOW_CONTRACT
}

export interface OfferCardAction {
    action: CardAction;
    transaction: Transaction;
}

@Directive()
export class OfferCardDirective {

    @Input()
    public transaction: Transaction;

    /**
     * event emitter
     */
    @Output()
    public selectAction: EventEmitter<OfferCardAction>;

    /**
     * possible card actions
     */
    public cardAction = CardAction;

    /**
     * current transaction state
     */
    public transactionState = TransactionState;

    public constructor() {
        this.selectAction = new EventEmitter();
    }

    public triggerAction(action: CardAction): void {
        this.selectAction.emit({ action, transaction: this.transaction });
    }
}
